import App from "next/app"
import '@/styles/globals.scss';
import '@/styles/pages/career/customize-career-page/_global_index.scss';

import  { QueryClient, QueryClientProvider, ReactQueryDevtools, I18nextProvider,
          i18n, SessionProvider, ProtectedRoutes, Loading, useRouter, useEffect,
          useState } from '@/imports-files/pages/app/app';

import HelmetMetaData from '@/pages/helmet_meta_data';
import ErrorFallback from '@/pages/error_boundary';
import {ErrorBoundary} from 'react-error-boundary';
import { getSession, init, identify, Identify, track } from '@/imports-files/common/common';
import CookieConsent, { Cookies } from "react-cookie-consent";
import Head from 'next/head';
import crypto from "crypto";
function MyApp({Component, pageProps, session})
{

  const queryClient                                   =  new QueryClient( {defaultOptions: {
                                                                            queries: {
                                                                                        cacheTime: 1000 * 60 * 60 * 24 // 24hrs
                                                                                      }
                                                                          }});

  const router                                        =  useRouter();
  const [ isLoading, setIsLoading ]                   =  useState(router.pathname.includes('view-job') || router.pathname.includes('careers') ? false : true);
  const [ cookieBar, setCookieBar ]                   =  useState(!router.pathname.includes("job-openings"))

  useEffect(() => {
                        if(router)
                        {
                          if(!(router.pathname == "/welcome")) ProtectedRoutes(router, session);
                          setIsLoading(false);
                        }
                        if(session) init(process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY, session?.uniq_reference)
                        const identifyObj = new Identify();
                        identifyObj.set('user_email', session?.email);
                        identifyObj.set('user_name', session?.name);
                        identifyObj.set('client_name', session?.client_name);
                        identify(identifyObj);
                   },[router])

  useEffect(() => {
    if(process.env.NEXT_PUBLIC_ENVIRONMENT == "production" && session?.intercom_id){
      var intercommAppId = process.env.NEXT_PUBLIC_INTERCOM_APP_ID
      window.intercomSettings = {
        api_base: "https://api-iam.intercom.io",
        app_id: intercommAppId,
        user_id: session.intercom_id,
        user_hash: session.encrypted_user_hash
      };

        // Intercom code snippet
      (function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src=`https://widget.intercom.io/widget/${intercommAppId}`;var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();
        }
  }, []);


  if(isLoading)
  {
    return <Loading />
  }
  const Layout = Component.layout || (({ children }) => <>{children}</>);
  pageProps.session = session;
   return(  <ErrorBoundary FallbackComponent={ErrorFallback}>
          <I18nextProvider i18n={i18n}>
          <SessionProvider session={pageProps.session}>
              <QueryClientProvider client={queryClient}>
                  {/* <HelmetMetaData /> */}
                  <Head>
                    <meta name="viewport" content="initial-scale=1.0, width=device-width" />
                  </Head>

                  {pageProps?.status_code == 404 ? <Component {...pageProps} /> :
                  <Layout>
                    <Component {...pageProps} />
                  </Layout>}
                  {cookieBar && <CookieConsent
                            location="bottom"
                            buttonText="Got It"
                            cookieName="CandidlyCookie"
                            className="custom-cookie-consent-class"
                          >
                          This site uses cookies. By continuing to browse the site you are agreeing to our use of cookies.
                </CookieConsent>}
                <ReactQueryDevtools />
              </QueryClientProvider>
          </SessionProvider>
          </I18nextProvider>
          </ErrorBoundary>
          )
}


MyApp.getInitialProps = async (appContext) => {
  const appProps = await App.getInitialProps(appContext)
  const session = await getSession({ req: appContext.ctx.req })
  return { ...appProps, session: session }
}


export default MyApp;
